<template>
	<div>
		<div :class="{app_phone:device!=='pc',app_pc:device=='pc'}" id="app" v-if="appShow">
			<router-view @login="login_isLogin" :key="device!=='pc'?Math.random():null"></router-view>
		</div>
		<div id="form" v-if="formShow">
			<router-view @login="login_isLogin"></router-view>
		</div>
		<Socket v-if="socketShow && socket" />
	</div>
</template>
<style>

</style>
<script>
	import Socket from '@_system/components/socket/index.vue'
	import loginMixins from '@_system/components/base/mixins/login/login.js'
	import * as dd from 'dingtalk-jsapi';
	// import {
	// 	Loading
	// } from 'element-ui';
	export default {
		mixins: [loginMixins],
		data() {
			return {
				singlepage: ['indexmodule', 'add', 'update', 'preview', 'report', 'penetrate'],
				routerMoudle: [],
				show: true,
				//appShow: false,
				//formShow: false,
				defalutRoute: '',
				socketShow: false,
				socket: window.config.socket ? true : false,
				device: window.systemMethods.device(),
				NavItemInit: false,
			}
		},
		created() {

		},
		mounted() {
			this.login_init()
			this.DDJSSDK()
		},
		watch: {

		},
		computed: {
			appShow() {
				return this.$store.state.system.appShow
			},
			formShow() {
				return this.$store.state.system.formShow
			}
		},
		methods: {
			DDJSSDK() {
				// let userAgentStr = window.navigator.userAgent;
				// if (/DingTalk/.test(userAgentStr)) {
				// 	alert(userAgentStr);
				// }
				//alert(dd.env.platform)
				if (dd.env.platform !== 'notInDingTalk') {
					this.$api.getjssdkcinfig().then((res) => {
						//alert(JSON.stringify(res))
						dd.config({
							agentId: res.agentId, // 必填，微应用ID
							corpId: res.corpId, //必填，企业ID
							timeStamp: res.timeStamp, // 必填，生成签名的时间戳
							nonceStr: res.nonceStr, // 必填，生成签名的随机串
							signature: res.signature, // 必填，签名
							type: 0, //选填，0表示微应用的jsapi，1表示服务窗的jsapi，不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
							jsApiList: [
								'device.notification.alert',
								'biz.chat.openSingleChat',
							],
						});

						// 优化后不再需要包括dd.ready，接口自动延后执行
						// dd.alert({
						// 	message: "亲爱的",
						// 	title: "提示", //可传空
						// 	buttonName: "收到",
						// }).then(() => {
						// 	// dd.quitPage({
						// 	// 	success: () => {},
						// 	// 	fail: () => {},
						// 	// 	complete: () => {},
						// 	// });
						// 	// dd.biz.chat.openSingleChat({
						// 	// 	corpId: 'ding8e67cb41ae8f0192ee0f45d8e4f7c288',
						// 	// 	userId: '172827656021672452',
						// 	// 	onSuccess: () => {},
						// 	// 	onFail: (e) => {
						// 	// 		alert(JSON.stringify(e))
						// 	// 	}
						// 	// });
						// }, () => {
						// 	//失败即相当于 onFail
						// });
					})
				}
			},


			// login_handle() {
			// 	this.login_status = 1
			// 	this.login()
			// },


			// login() {

			// 	// this.initSystemdata(e.systemdata)
			// 	if (!this.login_checkSinglePage()) {
			// 		this.appShow = true
			// 		this.formShow = false
			// 		this.login_getNavItem()
			// 		this.socketShow = true
			// 		// if (this.device == 'pc') {
			// 		// 	this.embedChatbot()
			// 		// }
			// 	} else {
			// 		this.appShow = false
			// 		this.formShow = true
			// 		this.login_getNavItem()
			// 	}
			// },

			async embedChatbot() {
				const t = window.config.difyChatbotConfig;
				if (t && t.token) {
					var e = !!t.isDev;
					const o = t.baseUrl || `https://${e?"dev.":""}udify.app`,
						n = `<i class="el-icon-chat-dot-round" style="font-size:20px;color:white;"></i>`,
						i = `<i class="el-icon-close" style="font-size:20px;color:white;"></i>`;
					if (!document.getElementById("dify-chatbot-bubble-button")) {
						e = document.createElement("div");
						e.id = "dify-chatbot-bubble-button", e.style.cssText =
							"position: fixed; bottom: 1rem; right: 1rem; width: 50px; height: 50px; border-radius: 25px; background-color: #155EEF; box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 8px 0px; cursor: pointer; z-index: 2147483647; transition: all 0.2s ease-in-out 0s; left: unset; transform: scale(1); :hover {transform: scale(1.1);}";
						const d = document.createElement("div");
						d.style.cssText =
							"display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; z-index: 2147483647;",
							d.innerHTML = n, e.appendChild(d), document.body.appendChild(e), e.addEventListener(
								"click",
								function() {
									var e = document.getElementById("dify-chatbot-bubble-window");
									e ? "none" === e.style.display ? (e.style.display = "block", d.innerHTML = i) : (e
										.style.display = "none", d.innerHTML = n) : ((e = document.createElement(
											"iframe")).allow = "fullscreen;microphone", e.title =
										"dify chatbot bubble window", e.id = "dify-chatbot-bubble-window", e.src =
										o + "/chatbot/" + t.token, e.style.cssText =
										"border: none; position: fixed; flex-direction: column; justify-content: space-between; box-shadow: rgba(150, 150, 150, 0.2) 0px 10px 30px 0px, rgba(150, 150, 150, 0.2) 0px 0px 0px 1px; bottom: 5rem; right: 1rem; width: 24rem; max-width: calc(100vw - 2rem); height: 40rem; max-height: calc(100vh - 6rem);border-radius: 0.75rem; display: flex; z-index: 2147483647; overflow: hidden; left: unset; background-color: #F3F4F6;",
										document.body.appendChild(e), d.innerHTML = i)
								})
					}
				} else {
					console.error("difyChatbotConfig is empty or token is not provided")
				}
			}

		},
		components: {
			Socket
		}
	}
</script>